import { render } from "./DenyRequest.vue?vue&type=template&id=d8b2f674"
import script from "./DenyRequest.vue?vue&type=script&lang=js"
export * from "./DenyRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__